class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    this.cartItems = document.querySelector('cart-items');
    this.cartFooter = document.getElementById('cart-footer');
    this.siteHeader = document.getElementById('shopify-section-header');
    this.cartDrawer = document.getElementById('cart-drawer');
    this.cartDrawerOpener = document.getElementById('cart-drawer-opener');
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) return;

    this.handleErrorMessage();

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);

    // Main cart sections renders updates on the cart page no matter the cart type
    if (themeSettings.template_name === 'cart') {
      formData.append('sections', this.cartItems.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      this.cartItems.querySelector('#cart-items-loader').classList.remove('display--hidden');
    // Cart notification renders updates
    } else if (themeSettings.cart_type == 'page') {
      this.cartNotification.setActiveElement(document.activeElement);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
    // Cart drawer renders updates
    } else {
      this.cartDrawerOpener.openDrawer('cart-drawer');
      this.cartDrawer.setActiveElement(document.activeElement);
      formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      this.cartItems.querySelector('#cart-items-loader').classList.remove('display--hidden');
    }

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        document.querySelectorAll('simple-modal-dialog').forEach((dialog) => {
          dialog.hide();
        });

        // Main cart sections renders updates on the cart page no matter the cart type
        if (themeSettings.template_name === 'cart') {
          this.cartItems.querySelector('#cart-items-loader').classList.add('display--hidden');
          this.cartItems.getSectionsToRender().forEach((section => {
            document.getElementById(section.id).innerHTML =
              this.getSectionInnerHTML(response.sections[section.id], section.selector);
          }));
          this.cartItems.hideEmptyCart();
        // Cart notification renders updates
        } else if (themeSettings.cart_type === 'page') {
          this.cartNotification.renderContents(response);
          this.cartNotification.open();
        // Cart drawer renders updates
        } else {
          this.cartItems.querySelector('#cart-items-loader').classList.add('display--hidden');
          this.cartDrawer.getSectionsToRender().forEach((section => {
            document.getElementById(section.id).innerHTML =
              this.getSectionInnerHTML(response.sections[section.id], section.selector);
          }));
          this.cartItems.hideEmptyCart();
          trapFocus(this.cartDrawer);
        }
      })
      .catch((e) => {
        console.error(e);
        if (!this.cartItems) return;
        this.cartItems.querySelector('#cart-items-loader').classList.remove('display--hidden');
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('[data-error-message-wrapper]');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('[data-error-message]');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('product-form', ProductForm);
